<template>
  <div class="form-base">
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Полное наименование"
          outlined
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          v-mask="Mask.INN_FOREIGN_ORG"
          label="ИНН"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <div class="form-base__title">
          Лицо, действующее от имени иностранного юридического лица без
          доверенности
        </div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeLastName.$model"
          :errorMessages="getValidationErrorText(v.assigneeLastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeName.$model"
          :errorMessages="getValidationErrorText(v.assigneeName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneePatronymic.$model"
          :errorMessages="getValidationErrorText(v.assigneePatronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model.trim="v.assigneeSnils.$model"
          :errorMessages="getValidationErrorText(v.assigneeSnils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  EMAIL,
  EMOJI,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  PERSON_NAME,
  SNILS_ROD,
} from '@/utils/validate';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { FieldName } from '@/constants';
import { Mask } from '@/constants';

export const proxyTrusteeForeignOrganizationModel = {
  name: '',
  email: '',
  inn: '',
  assigneeLastName: '',
  assigneeName: '',
  assigneePatronymic: '',
  assigneeSnils: '',
};

export const proxyTrusteeForeignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN_ROD,
  },
  assigneeLastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneePatronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeSnils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
};

export default {
  name: 'ProxyTrusteeForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    Mask,
    FieldName,
    getValidationErrorText,
  }),
};
</script>
